var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0262 9.56098C29.0262 14.8414 24.7457 19.122 19.4653 19.122C14.1849 19.122 9.9043 14.8414 9.9043 9.56098C9.9043 4.28059 14.1849 0 19.4653 0C24.7457 0 29.0262 4.28059 29.0262 9.56098ZM38.9268 36.5367V42.0001H0V36.5367C0 33.6387 1.0253 30.8594 2.85035 28.8103C4.6754 26.7611 8.17509 25.6099 10.7561 25.6099H28.1707C30.7517 25.6099 34.2514 26.7611 36.0765 28.8103C37.9015 30.8594 38.9268 33.6387 38.9268 36.5367Z",
    fill: "url(#paint0_linear_3_32007)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_32007",
    x1: 4.51115,
    y1: 0.00000126943,
    x2: 34.1119,
    y2: 36.7404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4DC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDUser);
export default __webpack_public_path__ + "static/media/d_user.39a377b4830bcf1639772a4520153ed0.svg";
export { ForwardRef as ReactComponent };